<template>
  <app-launcher-links
    :is-disabled="isSavingSettings"
    @go-to="goToAppBundle({ app: $event })"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import AppLauncherLinks from '../components/AppLauncherLinks.vue';
import { useAppLauncher, useAppLauncherRouting } from '../composables';

export default defineComponent({
  name: 'AppLauncherLinksContainer',
  components: { AppLauncherLinks },
  setup() {
    const { isSavingSettings } = useAppLauncher();
    const { goToAppBundle } = useAppLauncherRouting();
    return { isSavingSettings, goToAppBundle };
  },
});
</script>
